import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalPush.call(this, location).catch(err => err)
}


const  router= new Router({
  routes: [
    {
      path: '/',
      name: 'payment',
      component: () => import('../views/pays/payment.vue'),
      meta:{
        title:"光影存图"
      }
    },
    // {
    //   path: '/power',
    //   name: 'power',
    //   component: () => import('../views/power/power.vue'),
    //   meta:{
    //     title:"光影存图"
    //   }
    // },
    
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('../views/power/login.vue'),
    //   meta:{
    //     title:"光影存图"
    //   }
    // },
    {
      path: '/bindMobile',
      name: 'bindMobile',
      component: () => import('../views/power/bindMobile.vue'),
      meta:{
        title:"光影存图"
      }
    },{
      path: '/User',
      name: 'User',
      component: () => import('../views/User.vue'),
      meta:{
        title:"光影存图"
      }
    }

  ],
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js